"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Billing = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "47", height: "52", viewBox: "0 0 47 52", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M5.58308 51.5105C4.16644 51.5105 2.9537 51.0061 1.94488 49.9973C0.936053 48.9885 0.431641 47.7757 0.431641 46.3591V10.299C0.431641 8.88233 0.936053 7.6696 1.94488 6.66077C2.9537 5.65195 4.16644 5.14754 5.58308 5.14754H8.1588V2.57182C8.1588 1.84203 8.40564 1.23029 8.89932 0.736614C9.393 0.242934 10.0047 -0.00390625 10.7345 -0.00390625C11.4643 -0.00390625 12.076 0.242934 12.5697 0.736614C13.0634 1.23029 13.3102 1.84203 13.3102 2.57182V5.14754H33.916V2.57182C33.916 1.84203 34.1629 1.23029 34.6565 0.736614C35.1502 0.242934 35.7619 -0.00390625 36.4917 -0.00390625C37.2215 -0.00390625 37.8333 0.242934 38.3269 0.736614C38.8206 1.23029 39.0675 1.84203 39.0675 2.57182V5.14754H41.6432C43.0598 5.14754 44.2726 5.65195 45.2814 6.66077C46.2902 7.6696 46.7946 8.88233 46.7946 10.299V46.3591C46.7946 47.7757 46.2902 48.9885 45.2814 49.9973C44.2726 51.0061 43.0598 51.5105 41.6432 51.5105H5.58308ZM5.58308 46.3591H41.6432V20.6019H5.58308V46.3591ZM5.58308 15.4504H41.6432V10.299H5.58308V15.4504Z",
        fill: "#D57023"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { x: 4.32617, y: 17.8047, width: 39.7426, height: 28.9567, fill: "#D57023" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22.1117 45.8335V42.4939C18.7377 41.9431 16.431 39.8773 15.8457 36.5722H20.1148C20.7001 38.3281 22.1117 39.1199 24.0397 39.1199C26.0021 39.1199 27.2415 38.2248 27.2415 36.6755C27.2415 35.4016 26.5185 34.7475 24.7282 34.3344L21.3543 33.5081C18.5656 32.8539 16.3277 31.3047 16.3277 27.8962C16.3277 24.66 18.6344 22.3188 22.1117 21.8713V18.7383H25.7611V22.009C28.7908 22.6976 30.5811 24.7288 31.1664 27.552H27.0694C26.6218 26.2437 25.4512 25.2453 23.42 25.2453C21.5953 25.2453 20.4247 26.1748 20.4247 27.5864C20.4247 28.757 21.1821 29.4111 22.6281 29.7898L26.2087 30.6505C29.4105 31.4424 31.3729 33.3359 31.3729 36.4345C31.3729 39.7741 29.0662 41.9431 25.7611 42.4939V45.8335H22.1117Z",
        fill: "#FFF3EA"
      }
    )
  );
};
export default Billing;
